export default function MaybeShow({show, children, alternativeChildren}){
  if(show)
    return children

  return alternativeChildren ?? <></>
}